<app-video-modal
  [isOpen]="isVideoModalOpen"
  [videoUrl]="videoApiUrl"
  [pubType]="'VideoAcceuil'"
  [pageSize]="1"
  [pageNumber]="1"
  (close)="closeVideoModal()"
></app-video-modal>
<app-loader [isLoading]="loading"></app-loader>
<div class="chapeau-background"></div>

<ng-container *ngIf="showDelice">
  <div class="carda">
    <div class="carousel-wrap">
      <div class="carousel-container">
        <div class="carousel" #carousel>
          <div class="slide" *ngFor="let slide of mixedSlides">
            <img
              [src]="slide.imageUrl"
              [alt]="slide.type === 'book' ? 'Livre' : 'Publicité'"
              style="cursor: pointer"
              (click)="goToSlide(slide)"
            />
          </div>
        </div>

        <div class="guide-line"></div>
      </div>

      <button class="carousel-btn prev" (click)="moveCarousel(-1)">‹</button>
      <button class="carousel-btn next" (click)="moveCarousel(1)">›</button>
    </div>
  </div>
</ng-container>

<!-- Main Content Container -->
<div class="accueil-container">
  <!-- Header with Chapeau Background -->
  <div class="header-section">
    <div class="header-content">
      <h1 class="welcome-title">{{ "accueil.welcome" | translate }}</h1>
    </div>
  </div>

  <!-- Apps Grid Section -->
  <div class="apps-section">
    <div class="apps-section-background"></div>
    <div class="apps-grid">
      <!-- Row 1 -->
      <a routerLink="/observation" class="">
        <div class="app-icon">
          <img src="assets/acceuil/Icons/observation.png" alt="Observations" />
          <span class="badge" *ngIf="notificationCounts['observation']">{{
            notificationCounts["observation"]
          }}</span>
        </div>
        <div class="app-label">{{ "navigation.observations" | translate }}</div>
      </a>

      <a routerLink="/cahierdetext" class="">
        <div class="app-icon">
          <img
            src="assets/acceuil/Icons/cahier de texte.png"
            alt="Cahier de texte"
          />
          <span class="badge" *ngIf="notificationCounts['homework']">{{
            notificationCounts["homework"]
          }}</span>
        </div>
        <div class="app-label">{{ "accueil.Cahierdetexte" | translate }}</div>
      </a>

      <a routerLink="/discipline" class="">
        <div class="app-icon">
          <img src="assets/acceuil/Icons/discipline (2).png" alt="Discipline" />
          <span
            class="badge"
            *ngIf="
              notificationCounts['discipline'] || notificationCounts['punition']
            "
            >{{
              notificationCounts["discipline"] + notificationCounts["punition"]
            }}</span
          >
        </div>
        <div class="app-label">{{ "accueil.discipline" | translate }}</div>
      </a>

      <a routerLink="/emploi" class="">
        <div class="app-icon">
          <img
            src="assets/acceuil/Icons/emploi du temps.png"
            alt="Emploi du temps"
          />
        </div>
        <div class="app-label">{{ "navigation.timetable" | translate }}</div>
      </a>

      <!-- Row 2 -->
      <a routerLink="/carnet" class="">
        <div class="app-icon">
          <img
            src="assets/acceuil/Icons/carnet des notes.png"
            alt="Carnet scolaire"
          />
        </div>
        <div class="app-label">{{ "carnet.title" | translate }}</div>
      </a>

      <a routerLink="/avis" class="">
        <div class="app-icon">
          <img src="assets/acceuil/Icons/avis.png" alt="Avis" />
          <span class="badge" *ngIf="notificationCounts['circulaire']">{{
            notificationCounts["circulaire"]
          }}</span>
        </div>
        <div class="app-label">
          {{ "navigation.teacherNotices" | translate }}
        </div>
      </a>

      <a routerLink="/documents" class="">
        <div class="app-icon">
          <img src="assets/acceuil/Icons/documents.png" alt="Documents" />
          <span class="badge" *ngIf="notificationCounts['document']">{{
            notificationCounts["document"]
          }}</span>
        </div>
        <div class="app-label">{{ "accueil.documents" | translate }}</div>
      </a>

      <!-- Row 3 -->
      <a routerLink="/messagerie" class="">
        <div class="app-icon">
          <img src="assets/acceuil/Icons/chat.png" alt="Messagerie" />
          <span class="badge" *ngIf="totalUnreadMessages > 0">{{
            totalUnreadMessages
          }}</span>
        </div>
        <div class="app-label">{{ "navigation.messaging" | translate }}</div>
      </a>

      <a routerLink="/event" class="">
        <div class="app-icon">
          <img src="assets/acceuil/Icons/events.png" alt="Événements" />
          <span class="badge" *ngIf="notificationCounts['event']">{{
            notificationCounts["event"]
          }}</span>
        </div>
        <div class="app-label">{{ "navigation.events" | translate }}</div>
      </a>

      <a routerLink="/albums" class="">
        <div class="app-icon">
          <img src="assets/acceuil/Icons/gallery.png" alt="Photos" />
          <span class="badge" *ngIf="notificationCounts['galerie']">{{
            notificationCounts["galerie"]
          }}</span>
        </div>
        <div class="app-label">{{ "albums.title" | translate }}</div>
      </a>

      <a routerLink="/note" class="">
        <div class="app-icon">
          <img src="assets/acceuil/Icons/notes.png" alt="Notes" />
          <span class="badge" *ngIf="notificationCounts['examen']">{{
            notificationCounts["examen"]
          }}</span>
        </div>
        <div class="app-label">{{ "navigation.grades" | translate }}</div>
      </a>

      <!-- Row 4 -->
      <a routerLink="/contine" class="">
        <div class="app-icon">
          <img src="assets/acceuil/Icons/cantine.png" alt="Cantine" />
        </div>
        <div class="app-label">{{ "navigation.canteen" | translate }}</div>
      </a>

      <a routerLink="/paiement" class="">
        <div class="app-icon">
          <img src="assets/acceuil/Icons/paiement.png" alt="Paiements" />
          <span class="badge" *ngIf="notificationCounts['paiement']">{{
            notificationCounts["paiement"]
          }}</span>
        </div>
        <div class="app-label">{{ "accueil.payments" | translate }}</div>
      </a>

      <a routerLink="/rdvparental" class="">
        <div class="app-icon">
          <img src="assets/acceuil/Icons/rendezvous.png" alt="Rdv Parental" />
        
          
        </div>
        <div class="app-label">{{ "accueil.rdvParental" | translate }}</div>
      </a>
      <a routerLink="/infoenfant" class="">
          <div class="app-icon">
            <img
              src="assets/acceuil/Icons/information enfants.png"
              alt="Information Enfants"
            />
          </div>
          <div class="app-label">
            {{ "navigation.childInformation" | translate }}
          </div>
        </a>
        <div class="info-enfant-app-item">
  

        <ng-container *ngIf="showDelice">
        <a routerLink="/kissati" class="">
          <div class="app-icon">
            <img src="assets/acceuil/Icons/9issati.png" alt="9issati" />
          </div>
          <div class="app-label">{{ "navigation.stories" | translate }}</div>
        </a>
        <a routerLink="/conseilDelice" class="delice-app-item">
          <div class="app-icon">
            <img src="assets/acceuil/Icons/delice.png" alt="Conseils Délice" />
            <span class="badge" *ngIf="notificationCounts['publicity']">{{
              notificationCounts["publicity"]
            }}</span>
          </div>
          <div class="app-label">{{ "accueil.deliceAdvice" | translate }}</div>
        </a>
      </ng-container>
        <ng-container *ngIf="showEClass">
          <a routerLink="/e-class" class="">
            <div class="app-icon">
              <img src="assets/E-class.svg" alt="E-class" />
              <span class="badge" style="background-color: #10B981; color: white;">En cours</span>
            </div>
            <div class="app-label">E-class</div>
          </a>
        </ng-container>
        <a routerLink="/isalni" class="">
          <div class="app-icon">
            <img src="assets/icons/issalni.png" alt="Isalni" /> 
          </div>
          <div class="app-label">{{ "إسألني" | translate }}</div>
        </a>
        <a routerLink="/rafi9ni" class="" *ngIf="showRafi9ni">
          <div class="app-icon">
            <img
              src="assets/rafi9ni.jpg"
              alt="Rafi9ni"
            />
          </div>
          <div class="app-label">{{ "accueil.rafi9ni" | translate }}</div>
        </a>      </div>
    </div>
  </div>
</div>
